/**
 * Generated from TrashReturnLayout.fla
 */
export function TrashReturnLayout(this: ITrashReturnLayout) {
	const main = this.main;
	TrashReturnLayout_main.call(this.main);
	main.x = 512;
	main.y = 384;
	if (main.scale) main.scale.x = 0.500;
	if (main.scale) main.scale.y = 0.500;
	if (main.onLayout) main.onLayout();
	const hud = this.hud;
	TrashReturnLayout_hud.call(this.hud);
	hud.x = 0;
	hud.y = 0;
	if (hud.scale) hud.scale.x = 0.500;
	if (hud.scale) hud.scale.y = 0.500;
	if (hud.onLayout) hud.onLayout();
	return this;
}
export function TrashReturnLayout_main(this: ITrashReturnLayout_main) {
	const bins = this.bins;
	if (!bins[0] && bins.elementFactory) {
		bins[0] = bins.elementFactory(0,undefined);
	}
	if (bins[0]) {
		TrashReturnLayout_GarbageCan1.call(bins[0] as ITrashReturnLayout_GarbageCan1);
		bins[0].x = -460.75;
		bins[0].y = -109.4;
		bins[0].width = 297.18;
		bins[0].height = 422.53;
		if (bins[0].onLayout) bins[0].onLayout();
	}
	if (!bins[1] && bins.elementFactory) {
		bins[1] = bins.elementFactory(1,undefined);
	}
	if (bins[1]) {
		TrashReturnLayout_RecycleBin2.call(bins[1] as ITrashReturnLayout_RecycleBin2);
		bins[1].x = 46.8;
		bins[1].y = 0.7;
		bins[1].width = 337.59;
		bins[1].height = 479.99;
		if (bins[1].onLayout) bins[1].onLayout();
	}
	if (!bins[2] && bins.elementFactory) {
		bins[2] = bins.elementFactory(2,undefined);
	}
	if (bins[2]) {
		TrashReturnLayout_RecycleBin1.call(bins[2] as ITrashReturnLayout_RecycleBin1);
		bins[2].x = 458.4;
		bins[2].y = -112;
		bins[2].width = 295.40;
		bins[2].height = 421.40;
		if (bins[2].onLayout) bins[2].onLayout();
	}
	const parkBackground = this.parkBackground;
	TrashReturnLayout_parkBackground.call(this.parkBackground);
	parkBackground.x = -0.3;
	parkBackground.y = 0;
	parkBackground.width = 3328.00;
	parkBackground.height = 1536.00;
	if (parkBackground.onLayout) parkBackground.onLayout();
	const oscar = this.oscar;
	TrashReturnLayout_oscar.call(this.oscar);
	oscar.x = -675.6;
	oscar.y = 909.7;
	if (oscar.scale) oscar.scale.x = 0.968;
	if (oscar.scale) oscar.scale.y = 0.968;
	if (oscar.onLayout) oscar.onLayout();
	return this;
}
function TrashReturnLayout_parkBackground(this: ITrashReturnLayout_parkBackground) {
	if (this.setLayoutTexture) this.setLayoutTexture("sorting-bg.png", 0.500, 0.500);
	return this;
}
function TrashReturnLayout_RecycleBin1(this: ITrashReturnLayout_RecycleBin1) {
	if (this.setLayoutTexture) this.setLayoutTexture("recycle-bin1.png", 0.406, 0.940);
	return this;
}
function TrashReturnLayout_RecycleBin2(this: ITrashReturnLayout_RecycleBin2) {
	if (this.setLayoutTexture) this.setLayoutTexture("recycle-bin-3.png", 0.588, 1.200);
	return this;
}
function TrashReturnLayout_GarbageCan1(this: ITrashReturnLayout_GarbageCan1) {
	if (this.setLayoutTexture) this.setLayoutTexture("recycle-bin2.png", 0.479, 0.943);
	return this;
}
function TrashReturnLayout_oscar(this: ITrashReturnLayout_oscar) {
	const bubble = this.bubble;
	TrashReturnLayout_bubble.call(this.bubble);
	bubble.x = -140.95;
	bubble.y = -1007.25;
	bubble.width = 281.00;
	bubble.height = 317.00;
	if (bubble.onLayout) bubble.onLayout();
	const loadPoint = this.loadPoint;
	TrashReturnLayout_spawnPoints0.call(this.loadPoint);
	loadPoint.x = -140.25;
	loadPoint.y = -1020;
	loadPoint.width = 38.70;
	loadPoint.height = 40.00;
	if (loadPoint.onLayout) loadPoint.onLayout();
	return this;
}
function TrashReturnLayout_bubble(this: ITrashReturnLayout_bubble) {
	if (this.setLayoutTexture) this.setLayoutTexture("sortingbubble.png", 0.500, 0.500);
	return this;
}
function TrashReturnLayout_spawnPoints0(this: ITrashReturnLayout_spawnPoints0) {
	return this;
}
export function TrashReturnLayout_hud(this: ITrashReturnLayout_hud) {
	const homeButton = this.homeButton;
	TrashReturnLayout_homeButton.call(this.homeButton);
	homeButton.x = 216;
	homeButton.y = 329;
	homeButton.width = 292.00;
	homeButton.height = 302.00;
	if (homeButton.onLayout) homeButton.onLayout();
	return this;
}
function TrashReturnLayout_homeButton(this: ITrashReturnLayout_homeButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("home-btn.png", 0.500, 0.500);
	return this;
}
interface ITrashReturnLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ITrashReturnLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ITrashReturnLayoutSprite extends ITrashReturnLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ITrashReturnLayoutText extends ITrashReturnLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ITrashReturnLayoutPolygon extends Array<number> {
}
interface ITrashReturnLayout {
	readonly main: ITrashReturnLayout_main;
	readonly hud: ITrashReturnLayout_hud;
}
interface ITrashReturnLayout_main extends ITrashReturnLayoutContainer {
	readonly bins: ITrashReturnLayoutArray<ITrashReturnLayout_GarbageCan1|ITrashReturnLayout_RecycleBin2|ITrashReturnLayout_RecycleBin1>;
	readonly parkBackground: ITrashReturnLayout_parkBackground;
	readonly oscar: ITrashReturnLayout_oscar;
}
interface ITrashReturnLayout_parkBackground extends ITrashReturnLayoutSprite {
}
interface ITrashReturnLayout_RecycleBin1 extends ITrashReturnLayoutSprite {
}
interface ITrashReturnLayout_RecycleBin2 extends ITrashReturnLayoutSprite {
}
interface ITrashReturnLayout_GarbageCan1 extends ITrashReturnLayoutSprite {
}
interface ITrashReturnLayout_oscar extends ITrashReturnLayoutContainer {
	readonly bubble: ITrashReturnLayout_bubble;
	readonly loadPoint: ITrashReturnLayout_spawnPoints0;
}
interface ITrashReturnLayout_bubble extends ITrashReturnLayoutSprite {
}
interface ITrashReturnLayout_spawnPoints0 extends ITrashReturnLayoutContainer {
}
interface ITrashReturnLayout_hud extends ITrashReturnLayoutContainer {
	readonly homeButton: ITrashReturnLayout_homeButton;
}
interface ITrashReturnLayout_homeButton extends ITrashReturnLayoutSprite {
}
